
import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule({
  state: {
    data: []
  },
  mutations: {
    addNotify(state, item) {
      state.data.push(item);
    },
    close(state, id) {
      const index = state.data.findIndex(n => n.id === id);
      if (index !== -1) {
        state.data.splice(index, 1);
      }
    },
    closeByKey(state, key) {
      const index = state.data.findIndex(n => n.key === key);
      if (index !== -1) {
        state.data.splice(index, 1);
      }
    }
  },
  actions: {
    addNotify({ commit }, { text, error }) {
      const id = Date.now() + Math.random();
      commit('addNotify', { id, text, error });

      if (!error) {
        setTimeout(() => {
          commit('close', id);
        }, 10000);
      }
    },
    showSaving({ state, commit }, text = 'Сохранение изменений...') {
      // не дублируем, если уже показано
      if (state.data.some(n => n.key === 'saving')) return;
      const id = Date.now() + Math.random();
      commit('addNotify', { id, key: 'saving', text, error: false, loading: true });
    },
    hideSaving({ commit }) {
      commit('closeByKey', 'saving');
    }
  },
  getters: {
    notify: state => state.data
  }
});